export default __webpack_public_path__ + "static/media/Rubik-ExtraBoldItalic.73f49018.ttf";